import React from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function InternalIcon(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill={props?.fill}
      viewBox="0 0 20 20"
    >
      <path
        fillRule="evenodd"
        d="M10 1.5L3.5 4.75v5.25c0 3.86 2.55 7.47 6 8.5 3.45-1.03 6-4.64 6-8.5V4.75L10 1.5zm0 2.12 4.5 2.25v4.38c0 2.86-1.86 5.54-4.5 6.47-2.64-.93-4.5-3.61-4.5-6.47V5.87L10 3.62zM9.25 8a.75.75 0 011.5 0v2.19l.53.53a.75.75 0 11-1.06 1.06l-.75-.75A.75.75 0 019.25 10V8z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default InternalIcon;
